import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { userSsoStateParser } from '#validation/user';
export const UserLoginSsoStateResponseSchema = z.object({
    state: userSsoStateParser,
    workspaceId: z.string(),
});
export class UserLoginSsoStateResponseDto extends createZodDto(UserLoginSsoStateResponseSchema) {
}
